import axios from '@/axios-instance-node'
import type { ResponseType } from '@/types.ts'

export interface HttpRemoveNeighborhoodsFromSubgeoParams {
	urlParams: {
		id: string
	}
	payload: {
		neighborhoodIds: string[]
	}
	params: {
		responseType: ResponseType
	}
}

export const httpRemoveNeighborhoodsFromSubgeo = async ({
	urlParams,
	payload,
	params
}: HttpRemoveNeighborhoodsFromSubgeoParams) => {
	await axios.delete(
		`/v1/geo-mapping-sub-geos/${urlParams.id}/remove-neighborhoods`,
		{
			params,
			data: payload
		}
	)
}
